function ArticleTitle({ children }: { children: React.ReactNode }) {
  return <h2 className="text-form-title">{children}</h2>;
}

export default ArticleTitle;
